<div class="row g-0 bn-auth__container">
  <div class="col-lg-{{ isExtAuthMode ? '12' : '6' }} bn-auth__side">
    <div class="bn-auth__form">
      <div class="text-center">
        <img
          alt="Bunny.net logo"
          class="bn-auth__logo"
          src="/assets/images/logo-bunnynet-dark-blue.svg" />
        <div class="bn-auth__title">14-Day FREE Trial</div>
        <p class="bn-auth__description mb-5">You're just 5 minutes away from a faster website.</p>
      </div>
      @if (isExtAuthMode) {
        <div class="bn-auth__wp-login__helper-text p-3 my-4 text-center">
          <div class="d-inline-flex flex-row justify-content-center align-items-center mt-1">
            <div class="bn-auth__wp-login__helper-text__connected-logo">
              @if (wpQueries.source === 'wp-plugin') {
                <img
                  alt="WordPress logo"
                  class="bn-auth__wp-login__helper-text__connected-logo--size-wordpress align-middle"
                  src="/assets/libs/auth-pages/images/wordpress-logo.svg" />
              } @else if (wpQueries.source === 'cli') {
                <fa-icon
                  class="bn-auth__wp-login__helper-text__connected-logo--size-wordpress align-middle"
                  icon="terminal"
                  size="2x" />
              } @else if (wpQueries.source === 'discord') {
                <img
                  alt="Discord logo"
                  class="bn-auth__wp-login__helper-text__connected-logo--size-discord align-middle"
                  src="/assets/libs/auth-pages/images/discord-mark-blue.svg" />
              } @else {
                <fa-icon
                  class="bn-auth__wp-login__helper-text__connected-logo--size-wordpress align-middle"
                  icon="question-circle"
                  size="2x" />
              }
            </div>
            <div class="bn-auth__wp-login__helper-text__connecting-line align-middle"></div>
            <div class="bn-auth__wp-login__helper-text__connected-logo align-middle">
              <img
                alt="Bunnynet logo"
                class="bn-auth__wp-login__helper-text__connected-logo--size-bunnynet"
                src="/assets/web-ui/images/logo-bunny-dark.svg" />
            </div>
            <div class="bn-auth__wp-login__helper-text__connecting-icon">
              <fa-icon
                class="mt-6"
                icon="circle-check" />
            </div>
          </div>

          @if (unsafeDomainWarning) {
            <bn-web-ui-alert
              alertType="danger"
              class="text-start text-200-regular mt-4"
              headerIcon="circle-exclamation"
              [heading]="error"
              [showIcon]="true">
              Unrecognized {{ wpQueries.source | uppercase }} return domain<br /><strong>{{ unsafeDomainWarning }}</strong>
            </bn-web-ui-alert>
          } @else {
            <bn-web-ui-alert
              alertType="warning"
              class="text-start text-200-regular mt-4"
              headerIcon="circle-exclamation"
              [showIcon]="true">
              {{ pageText.description2 }}<br /><strong>{{ domainInfo }}</strong>
            </bn-web-ui-alert>
          }
        </div>
      }
      <form
        data-e2e="AuthPagesRegisterForm"
        [formGroup]="registerForm"
        (ngSubmit)="onSubmit()">
        <bn-web-ui-input
          data-e2e="AuthPagesRegisterEmail"
          formControlName="email"
          label="Email"
          placeholder="Email"
          size="md"
          type="email"
          [options]="{ hideRequiredLabel: true }" />
        <div class="mt-3">
          <bn-web-ui-input
            data-e2e="AuthPagesRegisterPassword"
            formControlName="password"
            label="Password"
            placeholder="Password"
            size="md"
            type="password"
            [options]="passwordInputSettings" />
        </div>
        <div
          class="bn-auth--password-strength my-3 lh-lg p-2"
          [ngClass]="{ 'bn-auth--password-strength--invalid': registerForm.get('password')?.touched && registerForm.get('password')?.invalid }">
          <div>
            <fa-icon
              [icon]="registerForm.get('password')?.value?.match('.{12,}') ? ['fas', 'circle-check'] : ['fas', 'circle-xmark']"
              [ngClass]="{
                'text-danger-6': !registerForm.get('password')?.value?.match('.{12,}') && registerForm.get('password')?.touched,
                'text-success-6': registerForm.get('password')?.value?.match('.{12,}'),
              }" />
            At least 12 characters long
          </div>
          <div>
            <fa-icon
              [icon]="registerForm.get('password')?.value?.match('(?=.*[^A-Za-z\\d])') ? ['fas', 'circle-check'] : ['fas', 'circle-xmark']"
              [ngClass]="{
                'text-danger-6': !registerForm.get('password')?.value?.match('(?=.*[^A-Za-z\\d])') && registerForm.get('password')?.touched,
                'text-success-6': registerForm.get('password')?.value?.match('(?=.*[^A-Za-z\\d])'),
              }" />
            One special character
          </div>
          <div>
            <fa-icon
              [icon]="registerForm.get('password')?.value?.match('(?=.*[a-z])') ? ['fas', 'circle-check'] : ['fas', 'circle-xmark']"
              [ngClass]="{
                'text-danger-6': !registerForm.get('password')?.value?.match('(?=.*[a-z])') && registerForm.get('password')?.touched,
                'text-success-6': registerForm.get('password')?.value?.match('(?=.*[a-z])'),
              }" />
            One lowercase letter
          </div>
          <div>
            <fa-icon
              [icon]="registerForm.get('password')?.value?.match('(?=.*[A-Z])') ? ['fas', 'circle-check'] : ['fas', 'circle-xmark']"
              [ngClass]="{
                'text-danger-6': !registerForm.get('password')?.value?.match('(?=.*[A-Z])') && registerForm.get('password')?.touched,
                'text-success-6': registerForm.get('password')?.value?.match('(?=.*[A-Z])'),
              }" />
            One uppercase letter
          </div>
          <div>
            <fa-icon
              [icon]="registerForm.get('password')?.value?.match('(?=.*[0-9])') ? ['fas', 'circle-check'] : ['fas', 'circle-xmark']"
              [ngClass]="{
                'text-danger-6': !registerForm.get('password')?.value?.match('(?=.*[0-9])') && registerForm.get('password')?.touched,
                'text-success-6': registerForm.get('password')?.value?.match('(?=.*[0-9])'),
              }" />
            One number
          </div>
        </div>
        <div class="mt-3 row g-0">
          <div class="col-xl-12">
            <bn-web-ui-checkbox
              data-e2e="AuthPagesRegisterAgreeTerms"
              formControlName="agreeTerms"
              inputName="Aggreement"
              size="sm"
              [hideErrorMessages]="true"
              [label]="termsLabel" />
            @if (registerForm.get('agreeTerms')?.errors?.required && registerForm.get('agreeTerms')?.touched) {
              <bn-web-ui-formcontrol-errors
                customError="In order to use bunny.net, you have to agree with our <strong>Terms of Service</strong>, <strong>Acceptable Use Policy</strong> and <strong>Privacy Policy</strong>." />
            }
          </div>
        </div>
        @if (error) {
          <bn-web-ui-alert
            alertType="danger"
            class="text-start mt-5"
            headerIcon="circle-exclamation"
            [heading]="error"
            [showIcon]="true">
            {{ errorMessage }}
          </bn-web-ui-alert>
        }

        <!-- captcha -->
        <div class="mt-5">
          <bn-auth-captcha-widget
            [errorOnlyCaptcha]="true"
            (hasPassed)="captchaPassed.set($event)"
            (powTokenEvent)="powToken.set($event)" />
        </div>

        <div class="mt-5">
          <button
            bn-web-ui-button
            data-e2e="AuthPagesRegisterSubmitButton"
            size="xl"
            type="submit"
            [disabled]="(!captchaPassed() && powToken() !== '') || unsafeDomainWarning.length > 0"
            [fullWidth]="true"
            [loading]="isLoading.submit">
            {{ pageText.submit }}
          </button>
        </div>
        <div class="bn-auth__hr">Or continue with</div>
        <div class="bn-auth__providers">
          <a
            class="bn-auth__providers__item"
            [href]="ssoUrlList.google"
            ><img
              alt="Google logo"
              src="/assets/images/common/google-logo.svg"
              title="Login with Google"
          /></a>

          <a
            class="bn-auth__providers__item bn-auth__providers__item--github"
            title="Login with GitHub"
            [href]="ssoUrlList.github">
            <img
              alt="GitHub logo"
              src="/assets/images/common/github-logo.svg"
              title="Login with GitHub" />
          </a>

          <a
            class="bn-auth__providers__item"
            [href]="ssoUrlList.gitlab"
            ><img
              alt="Gitlab logo"
              src="/assets/images/common/gitlab-logo.svg"
              title="Login with Gitlab"
          /></a>
        </div>
        @if (!tenantId) {
          <p class="text-center">
            Already have an account?
            <a
              class="btn btn-link"
              routerLink="../login"
              [queryParams]="wpQueries"
              >Log In</a
            >.
          </p>
        }
      </form>
    </div>
  </div>
  @if (!isExtAuthMode) {
    <div class="col-lg-6 d-none d-lg-flex bn-auth__side bn-auth__side--right">
      <bn-auth-register-slider
        [config]="sliderConfig"
        [loading]="isLoading.initial"
        [tenantId]="tenantId"
        [trustpilotConfig]="trustpilotConfig" />
    </div>
  }
</div>
